import { render, staticRenderFns } from "./cabinetechart.vue?vue&type=template&id=036d6f72&scoped=true&"
import script from "./cabinetechart.vue?vue&type=script&lang=js&"
export * from "./cabinetechart.vue?vue&type=script&lang=js&"
import style0 from "./cabinetechart.vue?vue&type=style&index=0&id=036d6f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d6f72",
  null
  
)

export default component.exports